<template>
    <div>
        <template v-if="nameMissing">
            <span v-bind:class="{'text-error' : highlightIfMissing, 'text-temporary' : !highlightIfMissing}">Not supplied</span>
        </template>
        <template v-else>
            <template v-if="guest.firstName">
                {{guest.firstName}}
            </template>
            <template v-else>
                <span class="text-temporary">first-name / </span>
            </template>
            <template v-if="guest.lastName">
                {{guest.lastName}}
            </template>
            <template v-else>
                <span class="text-temporary">/ last-name</span>
            </template>
        </template>
    </div>
</template>

<script>

    export default {
        name: 'GuestName',
        props: {
            guest: Object,
            highlightIfMissing: Boolean
        },
        computed: {
            nameMissing: function() {
                if (this.guest && !this.guest.firstName && !this.guest.lastName) {
                    return true;
                }
                return false;
            }
        },
        mounted() {
        }
    }

</script>